import DepartmentSelector from './DepartmentSelector';

export default DepartmentSelector;
